import search from './modules/search';
import geo from './modules/geo';
import request from './modules/request';
import contentful from './modules/contentful';
import trending from './modules/trending';
import proServices from './modules/pro-services';
import hierarchies from './modules/hierarchies';

function initalState () {
  return {
    isProHomepage: false,
  };
}

export default {
  namespaced: true,
  modules: {
    search,
    geo,
    request,
    contentful,
    trending,
    proServices,
    hierarchies,
  },
  state: initalState,
  getters: {
    isProHomepage (state) {
      return state.isProHomepage;
    },
  },
  mutations: {
    setIsProHomepage (state, data) {
      state.isProHomepage = data;
    },
  },
};
